"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesByIdPatchAsyncSlice = void 0;
const get_1 = require("./get.js");
const name_1 = require("./name.js");
const _api_1 = require("../../../api/index.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
const effects_1 = require("redux-saga/effects");
exports.coreInitiativesByIdPatchAsyncSlice = (0, xuder_1.createPatchAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: function* (action) {
                var _a, _b;
                const { assignedTo, initiativeStatusId } = action.data.patchInitiativeDescription;
                if (Number.isInteger(assignedTo)) {
                    yield (0, effects_1.put)(sonar_analytics_1.amplitudeActions.requestAmplitudeEvent({
                        id: sonar_analytics_1.AMPLITUDE_EVENT.OWNER_ASSIGNED
                    }));
                }
                if (Number.isInteger(initiativeStatusId)) {
                    const oldStatusId = yield (0, effects_1.select)((state) => state.core.initiatives.byId.get.data.initiativeStatusId);
                    const statuses = yield (0, effects_1.select)((state) => state.core.initiatives.statuses.get.data);
                    const oldStatusName = (_a = statuses === null || statuses === void 0 ? void 0 : statuses.find((status) => status.id === oldStatusId)) === null || _a === void 0 ? void 0 : _a.name;
                    const newStatusName = (_b = statuses === null || statuses === void 0 ? void 0 : statuses.find((status) => status.id === initiativeStatusId)) === null || _b === void 0 ? void 0 : _b.name;
                    yield (0, effects_1.put)(sonar_analytics_1.amplitudeActions.requestAmplitudeEvent({
                        data: {
                            from: oldStatusName,
                            to: newStatusName
                        },
                        id: sonar_analytics_1.AMPLITUDE_EVENT.STATUS_CHANGED
                    }));
                }
            },
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request) => get_1.coreInitiativesByIdGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiativesById((previous) => (Object.assign(Object.assign({}, previous), { id: request.initiativeId })))
        ]
    },
    name: name_1.CoreInitiativesByIdName,
    receive: false,
    request: true,
    requestHandler: _api_1.patchInitiativeById,
    yieldType: xuder_1.SagaYieldType.Latest
});
//# sourceMappingURL=patch.js.map